import React from 'react';
import {useFormRenderContext} from "v4/components/form/FormRender/context/FormRenderContext";
import PolInfoBox from "v4/components/ui/PolInfoBox/PolInfoBox";
import FormRow from "v4/components/form/FormRender/components/FormRow/FormRow";

export default function ImportRowsInfosSelectIdentifiers() {
    const {fields} = useFormRenderContext();

    return (
        fields.map(field => (
            <PolInfoBox key={field.name}
                        className={`import-rows-infos__select-identifier ${field.name}`}
            >
                <p className="text-right pol-info-box__title">{field.label}</p>
                <FormRow fieldName={field.name}/>
            </PolInfoBox>
        ))
    )
}
